import {
  IconCalendarEvent,
  IconUserPlus,
  IconUsersGroup,
  IconHistory,
  IconMail,
} from "@tabler/icons-react";

export const heroData = {
  meta: {
    title: "Angelfreunde 1866 e.V. – Deutschlands ältester Angelverein",
    description:
      "Willkommen bei den Angelfreunden 1866 e.V. – Deutschlands ältester Angelverein. Hier finden Sie Informationen zu Veranstaltungen, Mitgliedschaft, Vorstand und Vereinsgeschichte.",
  },
  overlay: {
    image: "/Hero/Hero.webp", // Lokal gehostet für bessere Performance
    alt: "Angelverein Banner mit See und Sonnenaufgang",
  },
  logo: {
    src: "/Logo.png",
    alt: "Vereinslogo Angelfreunde 1866 e.V.",
  },
  sponsor: {
    src: "https://placehold.co/160x80?text=Sponsor", // Beispiel für lokal gehostetes Sponsor-Logo
    alt: "Logo des Sponsors Fischerbedarf Berlin",
  },
  highlight: {
    badge: "🎉 160 Jahre Jubiläum",
    headline: "Willkommen bei den Angelfreunden 1866 e.V.",
    subline: "Deutschlands ältester Angelverein – seit 1866",
  },
  section: {
    title: "Unser Verein",
    subtitle: "Angelfreunde 1866 e.V.",
    text:
      "Der heutige Angler-Verein „Angelfreunde 1866 e.V.“ Berlin entstand bereits 1858 und wurde am 08. März 1866 als „Central-Verein der Angelfreunde zu Berlin“ in das Vereinsregister eingetragen. Wir sind Deutschlands ältester Angelverein.",
    heroImage: "/Vorstand_Gosen.webp",
    gridBanner: "/Hero/Hero_Angeln.webp",
    introTitle: "Petri heil auf der Homepage der ANGELFREUNDE 1866 e.V.!",
    introText:
      "Willkommen auf unserer neuen Website! Hier findest du alles rund um unseren traditionsreichen Verein – aktuelle Veranstaltungen, Infos zur Mitgliedschaft, zum Vorstand, zur Vereinsgeschichte und vielen weiteren Informationen. Viel Spaß beim Stöbern – und vielleicht sehen wir uns bald am Wasser!",
  },
};

/**
 * Navigation und Grid-Items
 */
export const items = [
  {
    title: "Veranstaltungsplan",
    description: "Behalte den Überblick über anstehende Veranstaltungen und wichtige Termine.",
    header: (
      <img
        src="/Hero/Kalender.webp"
        alt="Kalender mit Vereinsterminen"
        loading="lazy"
        className="flex flex-1 w-full h-[14rem] rounded-xl object-cover"
      />
    ),
    icon: <IconCalendarEvent className="h-4 w-4 text-neutral-500" />,
    link: "/veranstaltungsplan",
  },
  {
    title: "Mitgliedschaft",
    description: "Werde Teil unserer Gemeinschaft – jetzt Mitglied werden und alle Vorteile genießen.",
    header: (
      <img
        src="/Hero/Angelrute.webp"
        alt="Mitgliedschaft Angelfreunde 1866 e.V."
        loading="lazy"
        className="flex flex-1 w-full h-[14rem] rounded-xl object-cover"
      />
    ),
    icon: <IconUserPlus className="h-4 w-4 text-neutral-500" />,
    link: "/mitgliedschaft",
  },
  {
    title: "Vorstand",
    description: "Lern das engagierte Team kennen, das unseren Verein führt und gestaltet.",
    header: (
      <img
        src="/Hero/Vorstand.jpg"
        alt="Vorstandsmitglieder des Vereins"
        loading="lazy"
        className="flex flex-1 w-full h-[14rem] rounded-xl object-cover"
      />
    ),
    icon: <IconUsersGroup className="h-4 w-4 text-neutral-500" />,
    link: "/vorstand",
  },
  {
    title: "Vereinsgeschichte",
    description: "Tauch ein in die lange Geschichte unseres traditionsreichen Angelvereins.",
    header: (
      <img
        src="/Chronik/Jubiläum.webp"
        alt="Historische Vereinschronik"
        loading="lazy"
        className="flex flex-1 w-full h-[14rem] rounded-xl object-cover"
      />
    ),
    icon: <IconHistory className="h-4 w-4 text-neutral-500" />,
    link: "/vereinsgeschichte",
  },

  {
    title: "Kontakt",
    description: "Nimm Kontakt mit uns auf – wir freuen uns auf deine Nachricht.",
    header: (
      <img
        src="/Hero/Kontakt.webp"
        alt="Kontaktformular Symbol"
        loading="lazy"
        className="flex flex-1 w-full h-[14rem] rounded-xl object-cover"
      />
    ),
    icon: <IconMail className="h-4 w-4 text-neutral-500" />,
    link: "/kontakt",
  },
];